export enum AlertKey {
	backendErrorMessage = "backend-error-message",
	topupSuccess = "topup-success",
	contractRemoveSuccess = "contract-removed",
	contractGroupRemoveSuccess = "contract-group-removed",
	contractGroupUpdateSuccess = "contract-group-updated",
	contractCreateSuccess = "contract-created",
	contractEditSuccess = "contract-edited",
	contractGroupCreateSuccess = "contract-group-created",
	campaignTakeOfflineSuccess = "campaign-take-offline-success",
	campaignProductTakeOfflineSuccess = "campaign-product-take-offline-success",
	campaignCopyProductsContractsDeletedWarning = "campaign-copy-contract-warning",
	campaignEditProductsContractsNotFound = "campaign-edit-products-contracts-not-found",
	campaignOrderSuccess = "campaign-order-success",
	campaignOrderFail = "campaign-order-fail",
	campaignCopySuccess = "campaign-copy-success",
	campaignSaveSuccess = "campaign-save-success",
	buttonCopySuccess = "copy-button-success",
	productAddToBasket = "add-product-to-basket-success",
	productRemoveFromBasket = "remove-product-from-basket-warning",
	utmCodeConfirmation = "utm-code-confirmation",
	campaignAISmartfillFailedError = "campaign-ai-smartfill-failed-error",
	productSearchFiltersAISmartfillFailedError = "product-search-filters-ai-smartfill-failed-error",
}

export enum AlertType {
	success = "success",
	info = "info",
	warning = "warning",
	error = "error",
	custom = "custom",
}
